import styles from './RepaidPercentageIcon.module.css';

const RepaidPercentageIcon = ({
    radius,
    stroke,
    progress
}: {
    radius: number;
    stroke: number;
    progress: number;
}) => {
    const normalizedRadius = radius - stroke * 2;
    const circumference = normalizedRadius * 2 * Math.PI;

    const repaymentProgressStrokeOffset =
        circumference - progress * circumference;
    const totalProgressStrokeOffset = circumference - 1 * circumference;

    return (
        <svg height={radius * 2} width={radius * 2} className={styles.svg}>
            <circle
                className={styles.totalLoanRing}
                fill="transparent"
                strokeWidth={stroke}
                strokeDasharray={circumference + ' ' + circumference}
                style={{ strokeDashoffset: totalProgressStrokeOffset }}
                r={normalizedRadius}
                cx={radius}
                cy={radius}
            />
            <circle
                className={styles.loanProgressRing}
                fill="transparent"
                strokeWidth={stroke}
                strokeDasharray={circumference + ' ' + circumference}
                style={{ strokeDashoffset: repaymentProgressStrokeOffset }}
                r={normalizedRadius}
                cx={radius}
                cy={radius}
            />
            <text
                className={styles.percentageText}
                x="50%"
                y="50%"
                textAnchor="middle"
                alignmentBaseline="central"
            >
                {Math.floor(progress * 100)}
                <tspan className={styles.percentageSymbol} dy="4px">
                    %
                </tspan>
            </text>
        </svg>
    );
};

// eslint-disable-next-line import/no-default-export
export default RepaidPercentageIcon;
